import React, { useEffect, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { sendMail } from "../../Utils/SesSendMail";
import { reCaptchaValidate } from "../../Utils/RecaptchaV3";
import PropTypes from "prop-types";

const ContactForm = (props) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [howCanWeHelp, setHowCanWeHelp] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  const handleSetFieldValue = (e) => {
    const fieldName = e.target.name;
    switch (fieldName) {
      case "firstname":
        setFirstname(e.target.value);
        break;
      case "lastname":
        setLastname(e.target.value);
        break;
      case "company":
        setCompany(e.target.value);
        break;
      case "email":
        setEmail(e.target.value);
        break;
      case "howCanWeHelp":
        setHowCanWeHelp(e.target.value);
        break;
      default:
        return false;
    }
  };

  const initReCaptcha = (url, callback) => {
    const isScriptExist = document.getElementById("recaptcha");

    if (!isScriptExist) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      script.id = "recaptcha";
      script.onload = function () {
        if (callback) callback();
      };
      document.body.appendChild(script);
    }

    if (isScriptExist && callback) callback();
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    setSubmitStatus(true);

    grecaptcha.ready(function () {
      grecaptcha
        .execute(process.env.GATSBY_RECAPTCHA_V3_APIKEY, {
          action: "submit",
        })
        .then(function (token) {
          // Add your logic to submit to your backend server here.
          const sendEmailParams = {
            email: props.toEmail,
          };
          let emailSubject = "Hevelop Contact Form Submission by ";
          if (firstname) {
            sendEmailParams.firstname = firstname;
          }
          if (lastname) {
            sendEmailParams.lastname = lastname;
          }
          if (email) {
            sendEmailParams.fromEmail = email;
          }
          if (howCanWeHelp) {
            sendEmailParams.message = howCanWeHelp;
          }
          if (props.isDownload) {
            emailSubject = "Hevelop Report Download Submission by ";
          }
          if (company) {
            sendEmailParams.company = company;
            sendEmailParams.subject = `${emailSubject}${company}`;
          } else if (firstname && lastname) {
            sendEmailParams.subject = `${emailSubject}${firstname} ${lastname}`;
          }
          reCaptchaValidate(token)
            .then(() =>
              sendMail(sendEmailParams).then((result) => {
                if (result.statusCode === 200) {
                  window.dataLayer.push({ event: "formSubmit" });
                  setShowAlert(true);
                  setAlertType("text-success");
                  setAlertMessage(result.body);
                  if (props.onSuccess) {
                    props.onSuccess();
                  }
                } else {
                  setShowAlert(true);
                  setAlertType("text-danger");
                  setAlertMessage(result.body);
                }
                setSubmitStatus(false);
              })
            )
            .catch(() => {
              setShowAlert(true);
              setAlertType("text-danger");
              setAlertMessage("Invalid ReCaptcha, try again!");
            });
        });
    });
  };

  useEffect(() => {
    if (props.privacyLabel?.length) {
      document.querySelector('label[for="privacy"]').innerHTML =
        props.privacyLabel;
    }

    initReCaptcha(
      `https://www.google.com/recaptcha/api.js?render=${process.env.GATSBY_RECAPTCHA_V3_APIKEY}`
    );
  }, [initReCaptcha]);

  return (
    <Form onSubmit={handleFormSubmit}>
      {props.firstnameLabel && (
        <FloatingLabel
          controlId="firstname"
          label={props.firstnameLabel}
          className="mb-3"
        >
          <Form.Control
            size="lg"
            type="text"
            name="firstname"
            placeholder={props.firstnameLabel}
            required
            onChange={handleSetFieldValue}
          />
        </FloatingLabel>
      )}
      {props.lastnameLabel && (
        <FloatingLabel
          controlId="lastname"
          label={props.lastnameLabel}
          className="mb-3"
        >
          <Form.Control
            size="lg"
            type="text"
            name="lastname"
            placeholder={props.lastnameLabel}
            required
            onChange={handleSetFieldValue}
          />
        </FloatingLabel>
      )}
      {props.companyLabel && (
        <FloatingLabel
          controlId="company"
          label={props.companyLabel}
          className="mb-3"
        >
          <Form.Control
            size="lg"
            type="text"
            name="company"
            placeholder={props.companyLabel}
            required
            onChange={handleSetFieldValue}
          />
        </FloatingLabel>
      )}
      {props.emailLabel && (
        <FloatingLabel
          controlId="email"
          label={props.emailLabel}
          className="mb-3"
        >
          <Form.Control
            size="lg"
            type="email"
            name="email"
            placeholder={props.emailLabel}
            required
            onChange={handleSetFieldValue}
          />
        </FloatingLabel>
      )}
      {props.messageLabel && (
        <FloatingLabel
          controlId="howCanWeHelp"
          label={props.messageLabel}
          className="mb-3"
        >
          <Form.Control
            as="textarea"
            size="lg"
            name="howCanWeHelp"
            placeholder={props.messageLabel}
            required
            onChange={handleSetFieldValue}
          />
        </FloatingLabel>
      )}
      <Form.Group className="mb-5" controlId="privacy">
        <Form.Check type="checkbox" label={props.privacyLabel} required />
      </Form.Group>
      <button className="btn-green" type="submit" disabled={submitStatus}>
        {props.buttonLabel}
      </button>
      <p className={(showAlert ? "mt-4 " : "mt-4 d-none ") + alertType}>
        {alertMessage}
      </p>
    </Form>
  );
};

ContactForm.propTypes = {
  toEmail: PropTypes.string.isRequired,
  firstnameLabel: PropTypes.string,
  lastnameLabel: PropTypes.string,
  companyLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  messageLabel: PropTypes.string,
  privacyLabel: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  isDownload: PropTypes.bool,
};

export default ContactForm;
